import { useEffect, useState } from 'react'
import API from "../../api/phx";
import ReactHtmlParser from 'react-html-parser'

import styles from './BookingSiteOperatedBy.module.scss'

const textType = 'booking_site_operated_by'

export function BookingSiteOperated() {

  const [ html, setHtml ] = useState('')

  useEffect(() => {
    const getStandardText = (standardTextLink) => {
        API.get(`/text?types=${standardTextLink}`).then((result) => {
          const data = result.data.data;
          setHtml(data[0].body)
        });
  }
    getStandardText(textType);
  }, []);

  return html ? (

    <div className={ styles.operatedBy }>
      { ReactHtmlParser(html) }
    </div>

  ) : null

}